import React from 'react';
import Icon from 'components/AppIcon';

export default function BudgetSummary({ categories, totalBudget }) {
  const totalAllocated = categories?.reduce((s, c) => s + (c?.allocated_amount || 0), 0);
  const totalSpent = categories?.reduce((s, c) => s + (c?.spent_amount || 0), 0);
  const remaining = totalBudget - totalAllocated;
  const spentPct = totalAllocated > 0 ? Math.min((totalSpent / totalAllocated) * 100, 100) : 0;

  const stats = [
    { label: 'Total Budget', value: `$${totalBudget?.toLocaleString()}`, icon: 'Wallet', color: '#00E5FF' },
    { label: 'Allocated', value: `$${totalAllocated?.toLocaleString()}`, icon: 'PieChart', color: '#7B2FBE' },
    { label: 'Spent', value: `$${totalSpent?.toLocaleString()}`, icon: 'TrendingUp', color: spentPct >= 90 ? '#EF4444' : spentPct >= 70 ? '#F59E0B' : '#10B981' },
    { label: 'Unallocated', value: `$${Math.max(remaining, 0)?.toLocaleString()}`, icon: 'PiggyBank', color: remaining < 0 ? '#EF4444' : '#10B981' },
  ];

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 mb-6">
      {stats?.map((s) => (
        <div key={s?.label} className="bg-[rgba(255,255,255,0.04)] border border-[rgba(0,229,255,0.1)] rounded-xl p-4">
          <div className="flex items-center gap-2 mb-2">
            <div className="w-7 h-7 rounded-lg flex items-center justify-center" style={{ backgroundColor: `${s?.color}20` }}>
              <Icon name={s?.icon} size={14} color={s?.color} />
            </div>
            <span className="text-xs text-[#64748B]">{s?.label}</span>
          </div>
          <p className="text-xl font-bold font-mono" style={{ color: s?.color }}>{s?.value}</p>
        </div>
      ))}
    </div>
  );
}
